export default function CalendarIcon(props) {
  return (
    <svg
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 7.42969H20.2857"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3571 3.57031H2.92857C2.41708 3.57031 1.92654 3.7735 1.56487 4.13518C1.20319 4.49686 1 4.98739 1 5.49888V17.0703C1 17.5818 1.20319 18.0723 1.56487 18.434C1.92654 18.7957 2.41708 18.9989 2.92857 18.9989H18.3571C18.8686 18.9989 19.3592 18.7957 19.7209 18.434C20.0825 18.0723 20.2857 17.5818 20.2857 17.0703V5.49888C20.2857 4.98739 20.0825 4.49686 19.7209 4.13518C19.3592 3.7735 18.8686 3.57031 18.3571 3.57031Z"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.14453 1V3.57143"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1406 1V3.57143"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
